// Copyright ©️ 2026 eVolve MEP, LLC

import type { ReactNode } from 'react';

import { Divider, Flex, Text, type TextProps, type FlexProps } from '@mantine/core';

import { type EvolveIconName, EvolveIcon } from 'assets/icons/EvolveIcon';
import { InfoIcon } from 'components/Mantine/InfoIcon';
import { isNil, isNotNil } from 'helpers/isNotNil';

export const EditableDetailItem = ({
  name,
  icon = null,
  tooltip,
  renderValue,
  renderValueStyles,
  editing = false,
  EditComponent,
  noDivider = false,
  mih = 30,
}: {
  editing?: boolean;
  name: string;
  icon?: EvolveIconName | null;
  tooltip?: string;
  renderValue: ReactNode;
  /** Used only if `renderValue` is a `string`. */
  renderValueStyles?: TextProps;
  EditComponent?: ReactNode;
  noDivider?: boolean;
} & Pick<FlexProps, 'mih'>) => (
  <>
    <Flex justify="space-between" fz="sm" align="center" gap="xl" mih={mih} style={{ overflowX: 'auto' }}>
      <Flex gap="xs" align="center">
        <Flex align="center" gap={8} c="dimmed">
          <EvolveIcon icon={icon} size="sm" inline />
          <Text style={{ textWrap: 'nowrap' }}>{name}</Text>
        </Flex>
        <InfoIcon label={tooltip} tooltipProps={{ maw: 250 }} />
      </Flex>
      {editing && isNotNil(EditComponent) ? (
        EditComponent
      ) : isNil(renderValue) || typeof renderValue === 'string' ? (
        <Text {...renderValueStyles}>{renderValue || '--'}</Text>
      ) : (
        renderValue
      )}
    </Flex>
    {!noDivider && <Divider my="sm" />}
  </>
);
